// src/store/slices/counterSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Website } from '../../components/context/InfluencerContext';
import { AccountType, SocialNetworks, UserType } from '../../components/context/SignupContext';

export type ProfileState = {
  profile:
  {
    artist: {
      id: string;
      accountType: string;
      fullName: string;
      about: string;
      categories: Array<string>;
      website: Website;
      headshot: string;
      coverphoto: string;
      coverImage?: string;
      socialNetworks: SocialNetworks;
    } | null;
    creator: {
      id: string;
      fullName: string;
      accountType: string;
      about: string;
      categories: Array<string>;
      website: Website;
      headshot: string;
      coverphoto: string;
      socialNetworks?: SocialNetworks;
    } | null;
    influencer: {
      userType?: UserType;
      accountType?: AccountType;
      accountName: string;
      companyName?: string;
      profession?: string;
      categories?: string[];
      contentOptions?: string[];
      about: string;
      collaborations?: string[];
      coverphoto: string;
      coverImage: string;
      headshot: string;
      socialNetworks: SocialNetworks;
      artstyleProfileId?: string | null;
      website: string | null;
      pricing: Record<string, number>;
      artist: {
        styleName: string;
        pricing: {
          model: string;
          price: number;
        };
      };
      published?: boolean;
      licenses?: [{
        type: string;
        price: number;
      }],
      license?: {
        type: string;
        price: number;
      } | null;
    }
  } | null;
  isLoading: boolean
}

const initialState: ProfileState = {
  profile: null,
  isLoading: false
};

const profileSlice = createSlice({
  name: 'profile',
  initialState,
  reducers: {
    setProfile: (state, action: PayloadAction<ProfileState['profile']>) => {
      state.profile = action.payload;
    },
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    }
  }
});

export const { setProfile, setLoading } = profileSlice.actions;
export default profileSlice.reducer;
